document.addEventListener('DOMContentLoaded', function () {
    const paths = document.querySelectorAll('.home-svg .path-1, .home-svg .path-2, .home-svg .path-3, .home-svg .path-4, .home-svg .path-5, .home-svg .path-6, .home-svg .path-7, .home-svg .path-8');
    const lastPath = document.querySelector('.home-svg .path-8'); // Son harf

    lastPath.addEventListener('animationend', function () {
        // Tüm path'lerdeki animasyonları sıfırla
        paths.forEach(path => {
            path.style.animation = 'none'; // Animasyonu sıfırla
            // Zaman aşımıyla animasyonu tekrar uygula
            setTimeout(() => {
                const className = path.className; // Mevcut class
                path.style.animation = ''; // Animasyonu varsayılan olarak uygula
            }, 10); // Ufak bir gecikme (yeniden tetiklenmesi için)
        });
    });
});
